import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  CLEAR_USER_ERROR,
} from './actionTypes.js';

import {
  readProfile,
} from '../../services/api.js';

import { fetchChats } from '../chat/actions.js';

export const loginSuccess = (user_id) => ({
  type: LOGIN_SUCCESS,
  payload: user_id,
});

export const fetchProfileSuccess = (profile) => ({
  type: FETCH_PROFILE_SUCCESS,
  payload: profile,
});

export const fetchProfileFailure = (error) => ({
  type: FETCH_PROFILE_FAILURE,
  payload: error,
});

export const fetchUserData = (user_id) => async (dispatch) => {
  try {
    localStorage.setItem('user_id', user_id);
    dispatch(loginSuccess(user_id));
    dispatch(fetchProfile(user_id));
    dispatch(fetchChats(user_id));
  } catch (error) {
    dispatch({
      type: LOGIN_FAILURE,
      payload: error.message,
    });
  }
};

export const logoutAction = () => (dispatch) => {
  try {
    localStorage.removeItem('user_id');
    localStorage.removeItem('user');
    dispatch({ type: LOGOUT_SUCCESS });
  } catch (error) {
    dispatch({
      type: LOGOUT_FAILURE,
      payload: error.message,
    });
  }
};

export const fetchProfile = (user_id) => async (dispatch) => {
  try {
    const response = await readProfile(user_id);
    dispatch(fetchProfileSuccess(response.data));
  } catch (error) {
    dispatch(fetchProfileFailure(error.message));
  }
};

export const clearUserError = () => ({
  type: CLEAR_USER_ERROR,
});